<template>
  <div>
    <booking-menu-with-budget-header :title="$t('booking.hotel.title')" />

    <v-row />

    <v-card-title>
      <v-row>
        <v-col md="3" sm="5" cols="12">
          <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details />
        </v-col>
      </v-row>
    </v-card-title>
    <booking-hotel-data-table :search="search"> </booking-hotel-data-table>
  </div>
</template>

<script>
import BookingHotelDataTable from "../../components/Booking/BookingHotelDataTable.vue";
import BookingMenuWithBudgetHeader from "../../components/Booking/BookingMenuWithBudgetHeader";

export default {
  name: "BookingHotelView",
  components: { BookingMenuWithBudgetHeader, BookingHotelDataTable },
  data: () => ({
    search: ""
  }),
  computed: {},
  methods: {},
  created() {}
};
</script>

<style scoped></style>
